import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { LoginPageComponent } from './features/auth/login-page.component';
import { DashboardLayoutComponent } from './features/dashboard/dashboard-layout.component';
import { ModerationPageComponent } from './features/moderation/moderation-page.component';
import { ReportsPageComponent } from './features/reports/reports-page.component';
import { RecipesPageComponent } from './features/recipes/recipes-page.component';
import { CategoriesPageComponent } from './features/categories/categories-page.component';
import { UsersPageComponent } from './features/users/users-page.component';
import { UserDetailsPageComponent } from './features/users/user-details-page.component';
import { StatsPageComponent } from './features/stats/stats-page.component';
import { SettingsPageComponent } from './features/settings/settings-page.component';
import { ProfilePageComponent } from './features/profile/profile-page.component';
import { PrivacyPolicyPageComponent } from './features/legal/privacy-policy-page.component';
import { DataDeletionPageComponent } from './features/legal/data-deletion-page.component';

export const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'privacy-policy', component: PrivacyPolicyPageComponent },
  { path: 'data-deletion-request', component: DataDeletionPageComponent },
  {
    path: 'dashboard',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'stats' },
      { path: 'stats', component: StatsPageComponent },
      { path: 'moderation', component: ModerationPageComponent },
      { path: 'recipes', component: RecipesPageComponent },
      { path: 'categories', component: CategoriesPageComponent },
      { path: 'users', component: UsersPageComponent },
      { path: 'users/:id', component: UserDetailsPageComponent },
      { path: 'reports', component: ReportsPageComponent },
      { path: 'settings', component: SettingsPageComponent },
      { path: 'profile', component: ProfilePageComponent },
    ],
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', redirectTo: 'dashboard' },
];
